export const indexMethod = (index, that) => {
    return 1 + index + (that.currentPage - 1) * that.pageSize;
};

export const updatePageOption = (that, pageInfo) => {
    that.total = pageInfo.total;
};
